import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import LinkTile from 'components/LinkTile';
import App from 'modules/App';
import styles from '../../../OrganizationLogo.pcss';
const getCountry = (organization)=>{
    const { countryCode: alpha2Code } = organization;
    const countries = useSelector(App.selectors.countries);
    const country = find(countries, {
        alpha2Code
    });
    const localizationResources = useSelector(App.selectors.localizationResources);
    return get(localizationResources, [
        country.nameKey,
        'value'
    ], country.englishName);
};
const getInfoMessage = (organization)=>{
    const country = getCountry(organization);
    const { street, city, zipCode } = organization;
    return `${country}, ${street}, ${city} ${zipCode}`;
};
const HeadMessage = ({ organization })=>/*#__PURE__*/ _jsx("div", {
        className: "d-flex align-items-center mb-2",
        children: /*#__PURE__*/ _jsx("span", {
            children: organization.name
        })
    });
const OrganizationBox = ({ organizationMembership })=>{
    const { organization } = organizationMembership;
    const { logo, name } = organization;
    return /*#__PURE__*/ _jsx(LinkTile, {
        labelMessage: /*#__PURE__*/ _jsx(HeadMessage, {
            organization: organization
        }),
        infoMessage: getInfoMessage(organization),
        image: /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: logo,
            name: name,
            className: styles.logo
        }),
        hasBorder: true
    });
};
export default withStyles(styles)(OrganizationBox);
